import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

interface ProfileProviderProps {
  children: ReactNode;
}

interface ProfileContextType {
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  username: string;
  setUsername: Dispatch<SetStateAction<string>>;
  groups: string[];
  setGroups: Dispatch<SetStateAction<string[]>>;
  shortUsername: string;
  userId: string;
  setUserId: Dispatch<SetStateAction<string>>;
}

const ProfileContext = createContext<ProfileContextType | null>(null);

export const ProfileProvider = ({ children }: ProfileProviderProps) => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [userId, setUserId] = useState('');
  const [groups, setGroups] = useState<string[]>([]);

  const shortUsername = useMemo(() => {
    if (username.length >= 3) return username.slice(0, 3);
    if (username.length === 2) return username.slice(0, 2);
    if (username.length === 1) return username.slice(0, 1);
    return '';
  }, [username]);

  return (
    <ProfileContext.Provider
      value={{
        email,
        setEmail,
        username,
        setUsername,
        groups,
        setGroups,
        shortUsername,
        userId,
        setUserId,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error('useHelpContext must be used within a HelpContextProvider');
  }
  return context;
};
